import React from 'react';
import { Container, Typography, Box, Divider } from "@mui/material";

export default function ContactUs() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box sx={{ background: 'var(--bg-card)', p: 4, borderRadius: 3, border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-sm)' }}>
        <Typography variant="h4" fontWeight="800" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          We'd love to hear from you.
        </Typography>
        
        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" fontWeight="700" gutterBottom>
          Get in Touch
        </Typography>
        <Typography variant="body1" paragraph color="text.secondary" sx={{ lineHeight: 1.8 }}>
          If you have any questions, feedback, or concerns regarding Finaculator, please feel free to reach out to our support team.
        </Typography>

        <Typography variant="body1" paragraph color="text.secondary" sx={{ lineHeight: 1.8, mt: 2 }}>
          <strong>Email:</strong> support@biatom.org <br/>
          <strong>Address:</strong> Chennai, Tamil Nadu, India
        </Typography>

        <Typography variant="body1" paragraph color="text.secondary" sx={{ lineHeight: 1.8, mt: 4 }}>
          Our operating hours are Monday to Friday, 9:00 AM to 6:00 PM IST. We strive to respond to all inquiries within 24-48 hours.
        </Typography>
      </Box>
    </Container>
  );
}
